__turbopack_context__.v({
  "age": "PartnerCard-module__pp1XEW__age",
  "card": "PartnerCard-module__pp1XEW__card",
  "collected": "PartnerCard-module__pp1XEW__collected",
  "donateDetails": "PartnerCard-module__pp1XEW__donateDetails",
  "donateNow": "PartnerCard-module__pp1XEW__donateNow",
  "goal": "PartnerCard-module__pp1XEW__goal",
  "nametext": "PartnerCard-module__pp1XEW__nametext",
  "prgresstext": "PartnerCard-module__pp1XEW__prgresstext",
  "prog": "PartnerCard-module__pp1XEW__prog",
  "progressbar": "PartnerCard-module__pp1XEW__progressbar",
  "projectContent": "PartnerCard-module__pp1XEW__projectContent",
  "projectImage": "PartnerCard-module__pp1XEW__projectImage",
  "projectImageSize": "PartnerCard-module__pp1XEW__projectImageSize",
  "projectdonate": "PartnerCard-module__pp1XEW__projectdonate",
  "projectdonatep": "PartnerCard-module__pp1XEW__projectdonatep",
  "projectprgresslrg": "PartnerCard-module__pp1XEW__projectprgresslrg",
});
